<div style="height: 100%">
  <div class="sticky-table-event-ichiran">
    <table class="event-ichiran">
      <thead>
      <tr>
        <th></th>
        <th>
          <mat-checkbox style="padding-left:12px"
                        [(ngModel)]="eventService.allEventChecked"
                        [disabled]="!eventService.selectedEvents.length"
                        (change)="eventService.updateSimilarEventChecked($event.checked)">
          </mat-checkbox>
        </th>
        <th>予定日</th>
        <th>実施日</th>
        <th>作業の種類</th>
        <th>作業名</th>
        <th>対象のロット</th>
      </tr>
      </thead>
      <tbody *ngIf="(eventService.eventList
              | listFilter:'eventShubetsu':eventService.eventFilter.eventShubetsu:false
              | listFilter:'touyoHouhou':eventService.eventFilter.touyoHouhou:false
              | searchListFilter:'eventName':eventService.eventFilter.eventName
              | listFilter:'jisshiDate':eventService.eventFilter.jisshiDate:false
              | listFilter:'taishouEdukeDate':eventService.eventFilter.edukeDate:false) as filterdEventList;">
        <ng-container *ngIf="filterdEventList.length > 0 else noData">
          <tr *ngFor="let eventMeisai of filterdEventList"
              [ngClass]="{'selectable': eventService.checkEventSelectable(eventMeisai, true) || eventService.firstCheckedEvent.id === eventMeisai.id}"
              (click)="eventService.eventRowClicked(eventMeisai);">
            <td class="{{eventMeisai.eventShubetsu}}">
            </td>
            <td>
              <mat-checkbox style="padding-left:12px"
                            [(ngModel)]="eventMeisai.checked"
                            (ngModelChange)="eventService.setSelectedEvents(eventMeisai)"
                            (click)="$event.stopPropagation()"
                            [disabled]="!eventService.checkEventSelectable(eventMeisai) && eventService.firstCheckedEvent.id !== eventMeisai.id">
              </mat-checkbox>
            </td>
            <td>{{eventMeisai.yoteiDate}}</td>
            <td>{{eventMeisai.jisshiDate}}</td>
            <td>{{eventMeisai.eventShubetsuName}}</td>
            <td>{{eventMeisai.eventName}}</td>
            <td>
              {{commonService.getName(masterService.keishaMaster, eventMeisai.taishouKeisha, 'farmKeisha')}}
              {{eventMeisai.taishouLotName}}
            </td>
          </tr>
        </ng-container>
        <ng-template #noData>
          <tr>
            <td colspan="8">該当する作業はありません。</td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>
</div>

